import 'core-js';
import 'regenerator-runtime/runtime';
import 'requestidlecallback-polyfill';
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';

import { unregister } from './serviceWorker';
import Entrypoint from './components/Entrypoint';

// Load Apollo Client error messages in development
if (import.meta.env.MODE === 'development') {
  import('@axe-core/react').then(axe => axe.default(React, ReactDOM, 1000));

  // Load detailed Apollo Client error messages
  import('@apollo/client/dev').then(({ loadErrorMessages, loadDevMessages }) => {
    loadDevMessages();
    loadErrorMessages();
  });
}

const DEPLOY_RECOVERY_KEY = 'ospitek-deploy-recovery';
const DEPLOY_RECOVERY_WINDOW_MS = 120_000;
const MAX_DEPLOY_RECOVERY_RELOADS = 3;
const CHUNK_LOAD_ERROR_PATTERN =
  /ChunkLoadError|Loading chunk [\d]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i;

const canRecoverByReload = () => {
  const now = Date.now();
  const defaultState = { startedAt: now, attempts: 0 };

  try {
    const state = JSON.parse(window.sessionStorage.getItem(DEPLOY_RECOVERY_KEY) || 'null') || defaultState;

    if (now - state.startedAt > DEPLOY_RECOVERY_WINDOW_MS) {
      const next = { startedAt: now, attempts: 1 };
      window.sessionStorage.setItem(DEPLOY_RECOVERY_KEY, JSON.stringify(next));
      return true;
    }

    if (state.attempts >= MAX_DEPLOY_RECOVERY_RELOADS) {
      return false;
    }

    state.attempts += 1;
    window.sessionStorage.setItem(DEPLOY_RECOVERY_KEY, JSON.stringify(state));
    return true;
  } catch (_error) {
    // sessionStorage unavailable — fail closed to avoid infinite loops
    return false;
  }
};

const recoverFromDeploymentRace = (reason, details) => {
  if (!canRecoverByReload()) {
    console.error('[Deployment] Auto-recovery limit reached. Manual refresh required.', { reason, details });
    return;
  }

  console.warn('[Deployment] Asset load failed, attempting auto-reload.', { reason, details });
  window.location.reload();
};

// Chunk load errors during lazy loading (after app renders — inline script won't catch these).
window.addEventListener('unhandledrejection', event => {
  const reason = event.reason;
  const message = `${reason?.message || reason || ''}`;
  if (CHUNK_LOAD_ERROR_PATTERN.test(message)) {
    event.preventDefault?.();
    recoverFromDeploymentRace('chunk-load-error', message);
  }
});

if (document.getElementById('root')) {
  ReactDOM.render(<Entrypoint />, document.getElementById('root'));

  import('./util/duration').then(formatDuration => (window.formatDuration = formatDuration));

  // Unregister service worker
  unregister();

  // Make sure application is refreshed on tablet screens.
  if (window.navigator.standalone === true) {
    const reloadApp = () => {
      if (document.visibilityState === 'hidden') {
        if (
          window.location.pathname.startsWith('/kiosk/') &&
          !window.location.pathname.match(/^\/kiosk\/\d+\/charting\/\d+$/)
        ) {
          ReactDOM.unmountComponentAtNode(document.getElementById('root'));
        }
      } else {
        ReactDOM.render(<Entrypoint />, document.getElementById('root'));
      }
    };
    document.addEventListener('visibilitychange', reloadApp);
  }
}
